// frontend/src/services/portfolioService.ts
import apiClient from './apiClient';
import { 
  Portfolio, 
  CreatePortfolioRequest, 
  UpdatePortfolioRequest,
  PortfolioListResponse 
} from '../types/Portfolio';

export const portfolioService = {
  // Get all portfolios (admin)
  getAll: async (): Promise<Portfolio[]> => {
    return apiClient.get<Portfolio[]>('/api/admin/portfolios');
  },

  // Get single portfolio by ID (admin)
  getById: async (id: string): Promise<Portfolio> => {
    return apiClient.get<Portfolio>(`/api/admin/portfolios/${id}`);
  },

  // Get published portfolio by slug (public)
  getBySlug: async (slug: string): Promise<Portfolio> => {
    return apiClient.get<Portfolio>(`/api/public/portfolios/${slug}`);
  },

  // Create new portfolio
  create: async (data: CreatePortfolioRequest): Promise<Portfolio> => {
    return apiClient.post<Portfolio>('/api/admin/portfolios', data);
  },

  // Update portfolio
  update: async (id: string, data: UpdatePortfolioRequest): Promise<Portfolio> => {
    return apiClient.put<Portfolio>(`/api/admin/portfolios/${id}`, data);
  },

  // Publish portfolio
  publish: async (id: string, notes?: string): Promise<Portfolio> => {
    return apiClient.post<Portfolio>(`/api/admin/portfolios/${id}/publish`, { notes });
  },

  // Clone portfolio
  clone: async (id: string): Promise<Portfolio> => {
    return apiClient.post<Portfolio>(`/api/admin/portfolios/${id}/clone`);
  },

  // Delete portfolio
  delete: async (id: string): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/api/admin/portfolios/${id}`);
  },

  // Copy selected blocks to an existing portfolio
  copyBlocksToPortfolio: async (
    sourcePortfolioId: string,
    targetPortfolioId: string,
    blockIds: string[]
  ): Promise<Portfolio> => {
    return apiClient.post<Portfolio>(
      `/api/admin/portfolios/${sourcePortfolioId}/copy-blocks`,
      {
        targetPortfolioId,
        blockIds
      }
    );
  },

  // Create a new portfolio with selected blocks from source
  createPortfolioWithBlocks: async (
    sourcePortfolioId: string,
    title: string,
    blockIds: string[]
  ): Promise<Portfolio> => {
    return apiClient.post<Portfolio>(
      `/api/admin/portfolios/${sourcePortfolioId}/copy-blocks`,
      {
        title,
        blockIds
      }
    );
  },
};

export default portfolioService;